import React, { useEffect } from "react";
import { getQuotationFor } from "../../../Components/Functions/word.fun";

const CompanyDescription = ({
  businessName = "",
  address = "",
  data = "",
  allQData = "",
}) => {
  useEffect(() => {
    if (allQData?.input_info?.isGrowSlab)
      setTimeout(() => {
        const element = document.getElementById("gs-name");
        element.innerHTML = element.innerHTML.replace("GROW-BAG", "GROW-SLAB");
        element.innerHTML = element.innerHTML.replace("Grow bag", "Grow slab");
        element.innerHTML = element.innerHTML.replace(
          "grow bags",
          "grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow bags",
          "Grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow Bags",
          "Grow Slabs"
        );
        element.innerHTML = element.innerHTML.replace("Grow Bag", "Grow Slab");
        element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
        element.innerHTML = element.innerHTML.replace("Growbags", "Growslabs");
        element.innerHTML = element.innerHTML.replace("growbags", "growslabs");
      }, 1000);
  }, [allQData]);

  return (
    <div id="gs-name">
      <style>{`
        h3 {
          margin-top: 14px;
          margin-bottom: 10px;
          font-size: 30px;
          font-weight: bold;

        }
        th, td, tr {
          margin: -2px;
          border-collapse: collapse;
          paddingTop: -2px;
          border: 1px solid #181818;
          text-align: left;
          padding: 0px 3px;
          font-size: 13px;
        }
          th {
          text-transform : uppercase;
          font-size:bold;
          }
        table {
          border-collapse: collapse
        }  
      `}</style>
      <div
        style={{ borderTop: "1px solid #181818", marginBottom: "5px" }}
      ></div>
      <p>
        Dear {businessName},<br />
        {address}
      </p>
      <p>
        Thank you for showing interest in{" "}
        <span style={{ fontWeight: "bold", fontSize: "12px" }}>
          {getQuotationFor(data)}
        </span>{" "}
        by Kryzen Biotech Pvt Ltd (KBPL). As per our discussions, please find
        the detailed quotation below along with the project financials.
      </p>
      {/* <h3>Company Profile:</h3>
      <p>
        Established in the year 2019, Kryzen Biotech Private Limited is a
        trusted name engaged in providing hydroponic training and Hydroponics
        services with automation for high tech farming. Kryzen Biotech is a
        Controlled Environment Agriculture (CEA) specialist company that
        combines sustainable technology and modern farming techniques, to create
        highly productive and economically profitable models for the new-age
        urban farmer. In a world where innovation meets sustainability, our
        journey begins. As a pioneering hydroponic farm developer company, we
        embark on a mission to revolutionize agriculture, redefine farming
        practices, and cultivate a greener future. Rooted in cutting-edge
        technology and a deep commitment to environmental stewardship, we
        harness the power of hydroponics to cultivate crops efficiently,
        sustainably, and with unparalleled precision. At the heart of our vision
        lies a dedication to reimagining the way we grow, harvest, and nourish
        our communities. Welcome to the forefront of agricultural innovation.
      </p> */}
    </div>
  );
};

export default CompanyDescription;
